import { IOptionData } from "Components/UI/Select";
import { FilterOperationMap } from "Data/interfaces/Activities/IFilters";

export const operationsFormatObj = (t: any): Record<keyof FilterOperationMap, (custom?: boolean) => IOptionData> => ({
  equal: (custom?: boolean) => {
    return {
      value: 'equal',
      description: t('filterOperators.equal'),
      label: custom ? '=' : t('filterOperators.equal'),
    }
  },
  different: (custom?: boolean) => {
    return {
      value: 'different',
      description: t('filterOperators.different'),
      label: custom ? '≠' : t('filterOperators.different'),
    }
  },
  bigger: (custom?: boolean) => {
    return {
      value: 'bigger',
      description: t('filterOperators.bigger'),
      label: custom ? '>' : t('filterOperators.bigger'),
    }
  },
  smaller: (custom?: boolean) => {
    return {
      value: 'smaller',
      description: t('filterOperators.smaller'),
      label: custom ? '<' : t('filterOperators.smaller'),
    }
  },
  biggerOrEqual: (custom?: boolean) => {
    return {
      value: 'biggerOrEqual',
      description: t('filterOperators.biggerOrEqual'),
      label: custom ? '≥' : t('filterOperators.biggerOrEqual'),
    }
  },
  lessOrEqual: (custom?: boolean) => {
    return {
      value: 'lessOrEqual',
      description: t('filterOperators.lessOrEqual'),
      label: custom ? '≤' : t('filterOperators.lessOrEqual'),
    }
  },
  contain: (custom?: boolean) => {
    return {
      value: 'contain',
      description: t('filterOperators.contain'),
      label: t('filterOperators.contain'),
    }
  },
  doesNotContain: (custom?: boolean) => {
    return {
      value: 'doesNotContain',
      description: t('filterOperators.doesNotContain'),
      label: t('filterOperators.doesNotContain'),
    }
  },
  beginsWith: (custom?: boolean) => {
    return {
      value: 'beginsWith',
      description: t('filterOperators.beginsWith'),
      label: t('filterOperators.beginsWith'),
    }
  },
  endsWith: (custom?: boolean) => {
    return {
      value: 'endsWith',
      description: t('filterOperators.endsWith'),
      label: t('filterOperators.endsWith'),
    }
  },
  empty: (custom?: boolean) => {
    return {
      value: 'empty',
      description: t('filterOperators.empty'),
      label: custom ? t('filterOperators.emptyCustom') : t('filterOperators.empty'),
    }
  },
  notEmpty: (custom?: boolean) => {
    return {
      value: 'notEmpty',
      description: t('filterOperators.notEmpty'),
      label: custom ? t('filterOperators.notEmptyCustom') : t('filterOperators.notEmpty'),
    }
  },
  before: (custom?: boolean) => {
    return {
      value: 'before',
      description: t('filterOperators.before'),
      label: t('filterOperators.before'),
    }
  },
  after: (custom?: boolean) => {
    return {
      value: 'after',
      description: t('filterOperators.after'),
      label: t('filterOperators.after'),
    }
  },
  onOrBefore: (custom?: boolean) => {
    return {
      value: 'onOrBefore',
      description: t('filterOperators.onOrBefore'),
      label: t('filterOperators.onOrBefore'),
    }
  },
  onOrAfter: (custom?: boolean) => {
    return {
      value: 'onOrAfter',
      description: t('filterOperators.onOrAfter'),
      label: t('filterOperators.onOrAfter'),
    }
  },
  between: (custom?: boolean) => {
    return {
      value: 'between',
      description: t('filterOperators.between'),
      label: t('filterOperators.between'),
    }
  },
});

export const optionsOperationsObj: Record<string, (keyof FilterOperationMap)[]> = {
  Visibility: ['contain', 'different'],
  TopicAssignedUsers: ['equal', 'contain', 'different', 'empty', 'notEmpty'],
  ConstructionSiteDisciplines: ['equal', 'contain', 'different'],
  CommunicationTypes: ['contain', 'different', 'empty', 'notEmpty'],
  TopicPoints: ['equal', 'contain', 'different'],
  Stage: ['contain', 'different', 'empty', 'notEmpty'],
  Type: ['contain', 'different'],
  DueDate: ['equal', 'before', 'after', 'onOrBefore', 'onOrAfter', 'between', 'empty', 'notEmpty'],
  Priority: ['contain', 'different', 'empty', 'notEmpty'],
  Description: ['equal', 'different', 'contain', 'doesNotContain', 'beginsWith', 'endsWith', 'empty', 'notEmpty'],
  Title: ['equal', 'different', 'contain', 'doesNotContain', 'beginsWith', 'endsWith'],
  Identifier: ['equal', 'different', 'bigger', 'smaller', 'biggerOrEqual', 'lessOrEqual'],
  Status: ['contain', 'different'],
  CreationAuthor: ['contain', 'different'],
  CreationDate: ['equal', 'before', 'after', 'onOrBefore', 'onOrAfter', 'between'],
  CommentCount: ['empty', 'notEmpty'],
  UpdatedDate: ['equal', 'before', 'after', 'onOrBefore', 'onOrAfter', 'between'],
};

export const optionsDefaultOperationsObj: Record<string, (keyof FilterOperationMap)> = {
  Visibility: 'contain',
  TopicAssignedUsers: 'contain',
  ConstructionSiteDisciplines: 'contain',
  CommunicationTypes: 'contain',
  TopicPoints: 'contain',
  Stage: 'contain',
  Type: 'contain',
  DueDate: 'equal',
  Priority: 'contain',
  Description: 'contain',
  Title: 'contain',
  Identifier: 'equal',
  Status: 'contain',
  CreationAuthor: 'contain',
  CreationDate: 'equal',
  CommentCount: 'notEmpty',
  UpdatedDate: 'equal',
};

export const getPropertiesObj: Record<string, string[]> = {
  TopicAssignedUsers: ['Id'],
  ConstructionSiteDisciplines: ['ConstructionSiteDisciplinesId'],
  CommunicationTypes: ['TopicCommunicationTypeId'],
  TopicPoints: ['TopicPointId'],
  Stage: ['TopicStageId'],
  Type: ['TopicTypeId'],
  Status: ['TopicStatusId'],
  CreationAuthor: ['Id'],
};

export const arrayTopicKeysPtBr: Record<string, string> = {
  Visibility: 'Visibilidade',
  TopicAssignedUsers: 'Responsáveis',
  ConstructionSiteDisciplines: 'Disciplinas',
  CommunicationTypes: 'Meio',
  TopicPoints: 'Local',
  Stage: 'Etapa',
  Type: 'Tipo',
  DueDate: 'Prazo limite',
  Priority: 'Prioridade',
  Description: 'Observação',
  Title: 'Resumo',
  Identifier: 'Código',
  Status: 'Status',
  CreationAuthor: 'Autor',
  CreationDate: 'Data cadastro',
  CommentCount: 'Comentário',
  UpdatedDate: 'Data atualização',
};
